import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ShowRingIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Gaussian splat ring - 3D torus/ring representation */}
      {/* Outer ellipse */}
      <ellipse cx="12" cy="12" rx="9" ry="5" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Inner ellipse (hole) */}
      <ellipse cx="12" cy="12" rx="4" ry="2" stroke={color} strokeWidth={strokeWidth} fill="none" />
      {/* Ring surface fill (donut shape) */}
      <path
        d="M12 7c-5 0-9 2.2-9 5s4 5 9 5 9-2.2 9-5-4-5-9-5zM12 10c2.2 0 4 .9 4 2s-1.8 2-4 2-4-.9-4-2 1.8-2 4-2z"
        fill={color}
        fillRule="evenodd"
        opacity="0.3"
      />
      {/* Center axis indicator */}
      <circle cx="12" cy="12" r="1" fill={color} />
    </BaseIcon>
  ),
);

ShowRingIcon.displayName = 'ShowRingIcon';
